<template>
    <div>
        <section v-for="field in streamfield" :key="field.id">
            <WysiwygBlock v-if="field.type == 'wysiwyg'" :block="field" />
            <ZoomImage v-if="field.type == 'image' && field.value.allow_zoom" :block="field" />
            <ImageBlock v-else-if="field.type == 'image'" :block="field" />
            <HeadingBlock v-if="field.type == 'heading'" :block="field" />
            <BlockquoteBlock v-if="field.type == 'blockquote'" :block="field" />
            <TableBlock v-if="field.type == 'table'" :block="field" />
        </section>
    </div>
</template>

<script>
import BlockquoteBlock from "@/components/blocks/Blockquote"
import HeadingBlock from "@/components/blocks/Heading"
import ImageBlock from "@/components/blocks/Image"
import TableBlock from "@/components/blocks/Table"
import ZoomImage from "@/components/blocks/ZoomImage"
import WysiwygBlock from "@/components/blocks/Wysiwyg"

export default {
    name: 'StreamField',
    components: {
        WysiwygBlock,
        ImageBlock,
        HeadingBlock,
        BlockquoteBlock,
        TableBlock,
        ZoomImage,
    },
    props: {
        streamfield: Array
    },
}
</script>
<style scoped>
section {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
}
</style>
